import { Box } from '@mui/material';
import { EnvConnectionError } from './envConnectionErrorTypes';
import CloudDisconnectedIllustration from '../../../../icons/svg/CloudDisconnectedIllustration.svg?react';
import { Button, Typography } from '@sweep-io/sweep-design';
import { useSelector } from 'react-redux';
import { selectCrmOrg } from '../environmentsReducer';
import WithConnectOrgPermission from '../../../common/WithConnectOrgPermission';
import { appRoutes } from '../../../../constants/appRoutes';
import { useNavigate } from 'react-router';

export const SfEnvConnectionErrorPage = ({
  envConnectionError,
}: {
  envConnectionError: EnvConnectionError;
}) => {
  const { crmOrgId } = envConnectionError;
  const crmOrg = useSelector(selectCrmOrg(crmOrgId));
  const crmOrgEnvName = crmOrg?.name || '';
  const navigate = useNavigate();
  const message = (
    <>
      We had an issue connecting your <b>{crmOrgEnvName}</b> environment
    </>
  );

  const buttonText = 'Open Environment Settings';

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '20px',
        flexDirection: 'column',
      }}
    >
      <CloudDisconnectedIllustration />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center' }}>
        <Typography variant="h3">Connection Failed</Typography>
        <Typography variant="body">{message}</Typography>
      </Box>

      <WithConnectOrgPermission>
        <Button
          size="medium"
          onClick={() => {
            navigate(`${appRoutes.settings.route}?tab=Environments`);
          }}
        >
          {buttonText}
        </Button>
      </WithConnectOrgPermission>
    </Box>
  );
};
